<template>
  <a-breadcrumb class="breadcrumb" v-show="hiddenB">
    <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
      <router-link v-if="item.name != name && index != 1" :to="{ path: item.path === '' ? '/' : item.path }">
        {{ item.meta.title }}
      </router-link>
      <span v-else>{{ item.meta.title }}</span>
    </a-breadcrumb-item>

    <a-breadcrumb-item v-show="hasHistory">
      <span style="color:#268B94;cursor:pointer;" @click="$router.go(-1)">&laquo; 返回上页</span>
    </a-breadcrumb-item>

  </a-breadcrumb>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      breadList: [],
      hasHistory: false,
      hiddenB: true
    }
  },
  created () {
    this.getBreadcrumb()
    this.hiddenBread()
  },
  methods: {
    getBreadcrumb () {
      this.breadList = []
      // this.breadList.push({name: 'index', path: '/dashboard/', meta: {title: '首页'}})

      this.name = this.$route.name
      this.$route.matched.forEach(item => {
        // item.name !== 'index' && this.breadList.push(item)
        // 面包屑组件不显示组件
        if (item.name !== 'index') {
          this.breadList.push(item)
        }
      })

      if (window.history.length > 3) {
        this.hasHistory = true
      }
    },
    hiddenBread () {
      if (this.$route.path.indexOf('/dashboard/workplace') !== -1) {
        this.hiddenB = false
      }
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  }
}
</script>

<style scoped>
</style>
